module.exports = __webpack_public_path__ + "static/img/desktop-zzjggl.55a68f33.png";